@if (passwordPolicy) {
  <div class="my-3 box-validate-password">
    <div class="fs-base-l2 fw-medium text-black-pantone">
      {{ passwordStatus | translate }}
    </div>
    <div class="my-1 fs-base-l4 text-gray-pantone">
      {{ 'VALIDATION.Your password must contained' | translate }} :
    </div>
    @for (rule of validateRules; track rule) {
      @if (passwordPolicy[rule.key]) {
        <div
          class="text-asterisk mb-0 d-flex align-items-center"
          [ngClass]="{ 'text-green': rule.valid }"
        >
          <svg
            class="me-2 mb-1"
            width="24"
            height="24"
            stroke="currentColor"
          >
            <use
              [attr.href]="
                'assets/images/icons/' + getIconPath(rule.valid)
              "
            ></use>
          </svg>
          @if (rule.key === 'minimum_length') {
            <span class="fs-base-l2 mb-1">
              {{ 'VALIDATION.LENGTH-CHARACTER' | translate }}
              {{ passwordPolicy.minimum_length }}
              {{ 'VALIDATION.characters' | translate }}
            </span>
          }
          @if (rule.key !== 'minimum_length') {
            <span class="fs-base-l2 mb-1">{{
              rule.text | translate
            }}</span>
          }
        </div>
      }
    }
  </div>
}
